export default __webpack_public_path__ + "static/luz-8117d66aebe5c29f193a289839dd252f.jpg";